export var DEFAULT_READ_RATE = 0.075;
